module.exports = {
    MAP_X_COORDINATE: 'defaultMapXCoordinate',
    MAP_Y_COORDINATE: 'defaultMapYCoordinate',
    MAP_ZOOM: 'defaultMapZoom',
    SHOW_SANDRE_CODE: 'showSandreCode',
    SHOW_INSEE_CODE: 'showInseeCode',
}
